import { Helmet } from 'react-helmet-async';

import { useContext, useEffect, useState } from 'react';
// @mui
import {
  Button,
  Card,
  Checkbox,
  CircularProgress,
  Container,
  Grid,
  MenuItem,
  Paper,
  Popover,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
// components

import Iconify from '../../components/iconify';
import Scrollbar from '../../components/scrollbar';
// sections
import { UserListHead } from '../../sections/@dashboard/user';
// mock
// import USERLIST from '../_mock/user';
import { useNavigate } from 'react-router-dom';
import {
  ClientsAssignment,
  RemaningUnalocatedClients,
  UnalocatedClientsFirstPage,
} from 'src/components/services/httpServices';

import { AppContext } from 'src/components/Context/AppContext/app.context';
import ClientListToolbar from 'src/sections/@dashboard/clients/ClientListToolbar';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  // { id: 'id', label: 'Id', alignRight: false },
  { id: 'fullName', label: 'Name', alignRight: false },
  { id: 'dateOfBirth', label: 'Date Of Birth', alignRight: false },
  { id: 'passportNo', label: 'Passport number', alignRight: false },
  { id: 'ucinumber', label: 'UCI #', alignRight: false },
  { id: 'phoneNumber', label: 'Phone Number', alignRight: false },
  // { id: 'fileNumber', label: 'File #', alignRight: false },
  { id: 'email', label: 'Email', alignRight: false },
  // { id: '' },
];

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  //console.log('Array', array);
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    let sorted = [];
    sorted = array.filter((_user) => {
      const fullNameMatch = _user?.fullName?.toLowerCase().indexOf(query.toLowerCase()) !== -1;
      const dateOfBirthMatch = _user?.dateOfBirth ? _user?.dateOfBirth?.includes(query) : false;
      const phoneNumberMatch = _user?.phoneNumber ? _user?.phoneNumber?.includes(query) : false;
      const emailMatch = _user?.email ? _user?.email?.toLowerCase().includes(query.toLowerCase()) : false;
      const uciNumberMatch = _user?.ucinumber ? _user?.ucinumber?.toLowerCase().includes(query.toLowerCase()) : false;
      const fileNumberMatch = _user?.fileNumber
        ? _user?.fileNumber?.toLowerCase().includes(query.toLowerCase())
        : false;
      const applicationNumberMatch = _user?.applicationNumber
        ? _user?.applicationNumber?.toLowerCase().includes(query.toLowerCase())
        : false;

      return (
        fullNameMatch ||
        dateOfBirthMatch ||
        phoneNumberMatch ||
        emailMatch ||
        uciNumberMatch ||
        fileNumberMatch ||
        applicationNumberMatch
      );
    });
    // console.log('sorted:', sorted);
    return sorted;
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function ClientAssignment() {
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('desc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('id');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [USERLIST, setUsersList] = useState([]);
  const [COMPANIESLIST, setCLIENTSLIST] = useState([]);
  const [CLIENTSLIST, setClientsList] = useState([]);
  const [message, setMessage] = useState('');
  const [saved, setSaved] = useState(false);
  const [clientCount, setClientCount] = useState(0);
  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [openMessage, setOpenMessage] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const navigate = useNavigate();

  let { customers, dataFetched } = useContext(AppContext);

  const fetchRemaining = async () => {
    if (customers != null && dataFetched) {
      var remClients = customers.clients.filter((c) => c.userId == null);
      console.log('clients:', customers);
      setClientsList((prevClientsList) => [...prevClientsList, ...remClients]);
    }
  };

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      const response = await UnalocatedClientsFirstPage(rowsPerPage);
      // console.log('response', response);
      if (response !== null) {
        setClientsList(response.clients);
        setClientCount(response.totalClients);
        setLoading(false);
        //   console.log('After');
        await fetchRemaining();
        // const afterResponse = await RemaningUnalocatedClients();
        // setClientsList([...response.clients, ...afterResponse.clients]);
      }
    };
    fetch();
  }, []);
  const rowClicked = async (row) => {
    setSelectedRow(row);
  };
  const handelAssignment = async (selectedUsersList) => {
    const payload = {
      ids: selected,
    };
    if (selectedAgent == null) {
      setMessage('Please Select Agent.');
      setSaved(false);
      setOpenMessage(true);
    } else if (selected.length <= 0) {
      setMessage('Please Select Clients.');
      setSaved(false);
      setOpenMessage(true);
    } else {
      // console.log(payload);
      // console.log('AGent:', selectedAgent);
      let response = await ClientsAssignment(selectedAgent.id, payload);
      // console.log('PostResponse:', response);

      if (response.status == 200) {
        const isSelected = (user) => {
          let check = selected.includes(user.id);
          return !check;
        };
        const list = CLIENTSLIST.filter((e) => {
          if (isSelected(e)) {
            return e;
          }
        });
        //console.log('Users:', list);
        setClientsList(list);
        setSelected([]);
        setMessage(response.data);
        setSaved(true);
        setOpenMessage(true);
        // setTimeout(() => {
        //   navigate('/app/user');
        // }, 2000);
      } else {
        setMessage(response.data);
        setSaved(false);
        setOpenMessage(true);
        // setPosting(false);
      }
    }
  };
  const handleClose = () => {
    setOpenMessage(false);
  };
  const handleEdit = () => {
    // console.log('row:', selectedRow);
    navigate(`/app/EditClient/${selectedRow.id}`);
  };
  const handleDetails = () => {
    //  console.log('row:', selectedRow);
    // navigate(`/app/CompanyDetails/${selectedRow.id}`);
  };
  // const handelAssignment = () => {
  //   navigate('/app/AddClient');
  // };

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = CLIENTSLIST.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };
  const rowClickedHandle = async (row) => {
    navigate(`/app/ClientTabs/${row.id}/${true}`);
  };
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - CLIENTSLIST.length) : 0;

  const filteredUsers = applySortFilter(CLIENTSLIST, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;
  // console.log('selectedAgent:', selectedAgent);
  return (
    <>
      <Helmet>
        <title> Clients | Immigration System </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Clients Assignment
          </Typography>
          <Button variant="contained" onClick={handelAssignment}>
            Assign
          </Button>
        </Stack>

        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Card>
            <ClientListToolbar
              numSelected={selected.length}
              selectedUsers={selected}
              setSelected={setSelected}
              filterName={filterName}
              onFilterName={handleFilterByName}
              // deleteUsers={deleteClientsList}
              setSelectedAgent={setSelectedAgent}
            />

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <UserListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={CLIENTSLIST.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                      {
                        /* const { id, name, role, status, company, userEmail } = row; */
                      }
                      const {
                        id,
                        fullName,
                        email,
                        phoneNumber,
                        dateOfBirth,
                        applicationNumber,
                        ucinumber,
                        fileNumber,
                        passportNo,
                      } = row;
                      const selectedCompany = selected.indexOf(id) !== -1;

                      return (
                        <TableRow
                          hover
                          key={id}
                          tabIndex={-1}
                          role="checkbox"
                          selected={selectedCompany}
                          onClick={() => rowClicked(row)}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox checked={selectedCompany} onChange={(event) => handleClick(event, id)} />
                          </TableCell>
                          {/* <TableCell component="th" scope="row" padding="none">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {id}
                              </Typography>
                            </Stack>
                          </TableCell> */}
                          <TableCell onClick={() => rowClickedHandle(row)} component="th" scope="row" padding="dense">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {fullName}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell onClick={() => rowClickedHandle(row)} component="th" scope="row" padding="dense">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {dateOfBirth?.split('T')[0]}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell onClick={() => rowClickedHandle(row)} component="th" scope="row" padding="dense">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {passportNo}
                              </Typography>
                            </Stack>
                          </TableCell>{' '}
                          <TableCell onClick={() => rowClickedHandle(row)} component="th" scope="row" padding="dense">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {ucinumber}
                              </Typography>
                            </Stack>
                          </TableCell>{' '}
                          <TableCell onClick={() => rowClickedHandle(row)} component="th" scope="row" padding="dense">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {phoneNumber}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell onClick={() => rowClickedHandle(row)} component="th" scope="row" padding="dense">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {email}
                              </Typography>
                            </Stack>
                          </TableCell>
                          {/* <TableCell align="right">
                            <IconButton size="large" color="inherit" onClick={handleOpenMenu}>
                              <Iconify icon={'eva:more-vertical-fill'} />
                            </IconButton>
                          </TableCell> */}
                        </TableRow>
                      );
                    })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>

                  {isNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <Paper
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            <Typography variant="h6" paragraph>
                              Not found
                            </Typography>

                            <Typography variant="body2">
                              No results found for &nbsp;
                              <strong>&quot;{filterName}&quot;</strong>.
                              <br /> Try checking for typos or using complete words.
                            </Typography>
                          </Paper>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[25, 50, 100, 500]}
              component="div"
              count={clientCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
        )}
        {saved ? (
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            key={vertical + horizontal}
            open={openMessage}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
              {message}
            </Alert>
          </Snackbar>
        ) : (
          <Snackbar
            key={vertical + horizontal}
            anchorOrigin={{ vertical, horizontal }}
            open={openMessage}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
              {message}
            </Alert>
          </Snackbar>
        )}
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={handleEdit}>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Edits
        </MenuItem>
      </Popover>
    </>
  );
}
